import { FC } from 'react';

import { SystemPageType } from '@ravago/shared/page-data/enums/system-page-type';
import { OrderBaseUrls } from '@ravago/shared/page-data/models/elements';
import { Box } from '@ravago/shared/radiance/components/box/components/Box/Box';
import { Button } from '@ravago/shared/radiance/components/button/components/Button/Button';
import { useTranslations } from '@ravago/shared/translations/client';

import { SystemPageLink } from '../../../content/system-page-link/system-page-link';

interface Props {
   locale: string;
   orderBaseUrls: OrderBaseUrls;
   orderId: string;
   showOrderDetailButton?: boolean;
   showCallOffAgreementButton?: boolean;
   agreementNumber: string | undefined;
}

export const OrderLineButtons: FC<Props> = ({
   locale,
   orderBaseUrls,
   orderId,
   showOrderDetailButton = false,
   showCallOffAgreementButton = false,
   agreementNumber
}: Props) => {
   const translate = useTranslations();

   return (
      <Box gap="sm" direction="column">
         {showCallOffAgreementButton && agreementNumber !== undefined && (
            <Box width="100%">
               <SystemPageLink
                  baseRoute={orderBaseUrls.callOffAgreementBaseUrl}
                  locale={locale}
                  type={SystemPageType.CALL_OFF_ORDER_DETAIL}
                  slug={agreementNumber}
               >
                  <Button fullWidth variant="primary">
                     {translate('page-consumer.order-line-flyout.call-off-agreement')}
                  </Button>
               </SystemPageLink>
            </Box>
         )}
         <Box gap="sm" width="100%">
            {showOrderDetailButton && orderId && (
               <SystemPageLink baseRoute={orderBaseUrls.orderDetailBaseUrl} locale={locale} type={SystemPageType.ORDER_DETAIL} slug={orderId}>
                  <Button fullWidth variant={showCallOffAgreementButton && agreementNumber ? 'secondary' : 'primary'}>
                     {translate('page-consumer.order-line-flyout.order-details')}
                  </Button>
               </SystemPageLink>
            )}
            <SystemPageLink baseRoute={orderBaseUrls.myProductsAndPricesBaseUrl} locale={locale} type={SystemPageType.MY_PRODUCTS_AND_PRICES}>
               <Button fullWidth variant="secondary">
                  {translate('page-consumer.order-line-flyout.new-quote')}
               </Button>
            </SystemPageLink>
         </Box>
      </Box>
   );
};
